import moment from 'moment';
import _ from 'lodash';
// @ts-ignore
import { hMacAjax as fetch } from '../httpService';
const default_map = { id: 'id', parentId: 'parent_id', children: 'children' };
export enum UploadType {
    // eslint-disable-next-line no-unused-vars
    UNSET,
    // eslint-disable-next-line no-unused-vars
    VIDEO = 2,
    // eslint-disable-next-line no-unused-vars
    AUDIO = 3
}

export interface RequestResult {
    success: boolean;
    code: string;
    msg: string;
    total?: number;
}

export enum Method {
    // eslint-disable-next-line no-unused-vars
    GET = 'get',
    // eslint-disable-next-line no-unused-vars
    POST = 'post',
    // eslint-disable-next-line no-unused-vars
    PUT = 'put',
    // eslint-disable-next-line no-unused-vars
    DELETE = 'delete'
}

export type RequestOptionType = {
    url: string;
    method: Method;
    headers?: any;
    params?: any;
    body?: any;
    data?: any;
    mode: 'cors';
};
export const removeHTMLTag = function (str: string) {
    if (!str) return '';
    str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
    str = str.replace(/[ |]*\n/g, '\n'); //去除行尾空白
    str = str.replace(/\n[\s| ]*\r/g, '\n'); //去除多余空行
    str = str.replace(/&nbsp;/gi, ' '); //去掉&nbsp;
    str = str.replace(/\s/g, ''); //将空格去掉
    return str;
};

export default class Utils {
    static dateFormat(date: string | number | Date, format: string = 'YYYY-MM-DD HH:mm:ss'): string {
        return moment(date).format(format);
    }
    // @ts-ignore
    static expandTreeData(treeData, result: any = {}) {
        if (treeData && treeData['id']) result[treeData['id']] = treeData;
        for (const treeDataKey in treeData) {
            if (treeData[treeDataKey] && typeof treeData[treeDataKey] === 'object') {
                this.expandTreeData(treeData[treeDataKey], result);
            }
        }
        return result;
    }
    // @ts-ignore
    static formatSize(size) {
        if (!size) return 0;
        let kb = 1024,
            unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(size) / Math.log(kb));
        return (size / Math.pow(kb, i)).toPrecision(4) + ' ' + unit[i];
    }

    static formatTime(time: number) {
        const date = new Date(time * 1000); // 将时间戳转换为毫秒级别
        const hours = date.getUTCHours().toString().padStart(2, '0'); // 获取小时，并补充前导零
        const minutes = date.getUTCMinutes().toString().padStart(2, '0'); // 获取分钟，并补充前导零
        const seconds = date.getUTCSeconds().toString().padStart(2, '0'); // 获取秒，并补充前导零
        if (Number(hours) > 0) {
            return `${hours}:${minutes}:${seconds}`; // 大于1小时，显示 hh:mm:ss
        } else {
            return `${minutes}:${seconds}`; // 小于1小时，显示 mm:ss
        }
    }
    // @ts-ignore
    genConvertProp(data, map) {
        const tmpData = data;
        for (const key in map) {
            if (typeof map[key] === 'function') {
                tmpData[key] = map[key](tmpData);
            } else tmpData[key] = tmpData[map[key]];
        }
        return tmpData;
    }

    convertTree<T>(data: any[] | any, convertType: any): T {
        const tmpObj = {},
            result: any = [];
        if (!data) return result;

        let idProperty: any, keyProperty: any, parentIdProperty: any, childrenProperty: any, cloneData: any,
            length: any;
        idProperty = convertType.id;
        keyProperty = convertType.key || idProperty;
        parentIdProperty = convertType.pId;
        childrenProperty = convertType.children;
        cloneData = _.cloneDeep(data);
        length = cloneData.length;
        for (let i = 0, len = length; i < len; i++) {
            const item = cloneData[i];
            item['path'] = item[parentIdProperty];
            item['pathName'] = item['text'];
            // @ts-ignore
            tmpObj[item[keyProperty]] = item;
        }
        for (let i = 0, len = length; i < len; i++) {
            const item = cloneData[i],
                // @ts-ignore
                parent = tmpObj[item[parentIdProperty]];
            if (parent) {
                parent[childrenProperty] = parent[childrenProperty] ? parent[childrenProperty] : [];
                this.setAttr(item, convertType, tmpObj);
                const resultChild = this.genConvertProp(item, convertType);
                parent[childrenProperty].push(resultChild);
            } else {
                this.setAttr(item, convertType, tmpObj);
                const resultChild = this.genConvertProp(item, convertType);
                result.push(resultChild);
            }
        }
        return result;
    }
    // @ts-ignore
    setAttr(item, map, obj) {
        item['text'] = item[map.name || map.title];
        item['depth'] = 0;
        item['pathName'] = this.getPathName(item, obj, map).join('/');
        item['path'] = this.getPath(item, obj, map).join('/');
        item['depth'] = item['path'] ? item['path'].split('/').length - 1 : 0;
    }
    // @ts-ignore
    getPathName(item, obj, map, r: string[] = []) {
        const name = item[map.name || map.title || map.text],
            parentId = item[map.pId || map.parentId || map.parent_id];
        if (name) r.unshift(name);
        if (obj[parentId]) this.getPathName(obj[parentId], obj, map, r);
        return r;
    }
    // @ts-ignore
    treeSearch(data, searchResult, expandData, searchValue, map: any = default_map) {
        const expandedKey: Set<string> = new Set(),
            r: any[] = [];
        for (let i = 0, len = searchResult.length; i < len; i++) {
            const item = searchResult[i];
            if (item.path) {
                const path = item.path,
                    pathList = path.split('/'),
                    pathLen = pathList.length;
                for (let j = pathLen - 1; j >= 0; j--) {
                    const currentId = pathList[j],
                        currentItem = expandData[currentId];
                    if (j > 0) {
                        const parentId = pathList[j - 1],
                            parent = this.getDta(data, parentId, map);
                        if (parent) {
                            if (parent['children']) {
                                let hasItem = this.getDta(parent['children'], currentId, map);
                                if (!hasItem) {
                                    parent[map['children']].push(currentItem);
                                }
                            } else {
                                parent[map['children']] = [currentItem];
                            }
                            expandedKey.add(parentId);
                        }
                    }
                    if (j === 0) {
                        let hasItem = this.getDta(r, currentId, map);
                        if (!hasItem) r.push(this.getDta(data, currentId, map));
                    }
                }
            }
        }
        if (!searchValue) {
            const expandedKeyList: string[] = [];
            for (const key in expandData) {
                const item = expandData[key],
                    pId = item[map['parentId'] || map['pId']];
                if (!expandData[pId]) expandedKeyList.push(key);
            }
            return {
                data: r,
                expandedKeys: expandedKeyList
            };
        }
        return {
            data: r,
            expandedKeys: Array.from(expandedKey) as string[]
        };
    }
    // @ts-ignore
    getDta(data, id, map) {
        for (let i = 0, len = data.length; i < len; i++) {
            const item = data[i];
            if (item[map['id']] === id) return item;
        }
        return false;
    }
    // @ts-ignore
    addParams2Tree(treeData, params) {
        const result: any[] = [];
        for (let i = 0, len = treeData.length; i < len; i++) {
            result.push(this.genConvertProp(treeData[i], params));
        }
        return result;
    }
    // @ts-ignore
    searchItemByText(treeData, text, searchField, map) {
        const result: any[] = [],
            field: string = searchField ? searchField : map['title'] || 'title';
        if (!text) {
            for (const key in treeData) {
                result.push(treeData[key]);
            }
            return result;
        }
        for (const key in treeData) {
            if (treeData[key] && treeData[key][field].indexOf(text) !== -1) {
                result.push(treeData[key]);
            }
        }
        return result;
    }
    // @ts-ignore
    getPath(item, obj, map, r: string[] = []) {
        const id = item[map.id || map.key],
            parentId = item[map.pId || map.parentId || map.parent_id];
        if (id) r.unshift(id);
        if (obj[parentId]) this.getPath(obj[parentId], obj, map, r);
        return r;
    }

    getPropValByProp(data: any[] | any, prop: string, r: any[] = []) {
        if (data && data[prop]) r.push(data[prop]);
        for (const key in data) {
            if (data[key] && typeof data[key] === 'object') {
                this.getPropValByProp(data[key], prop, r);
            }
        }
        return r;
    }
    // @ts-ignore
    getValByProp(data: any[] | any, prop: any, propVal: any, r: any = { found: false }) {
        if (!data) return r;
        if (data.hasOwnProperty(prop) && data[prop] === propVal) {
            r.found = true;
            r.result = data;
        }
        for (let key in data) {
            if (data[key] && typeof data[key] === 'object') {
                // @ts-ignore
                const tmp = this.getValByProp(data[key], prop, propVal, r);
                if (tmp.found) return tmp;
            }
        }
        return r;
    }
}

export class Request {

    static get<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        // @ts-ignore
        return fetch.get(url, params, { headers });
    }

    static post<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        // @ts-ignore
        return fetch.post(url, params, { headers });
    }

    static delete<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        // @ts-ignore
        return fetch.delete(url, params, { headers });
    }

    static put<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        // @ts-ignore
        return fetch.put(url, params, { headers });
    }

    static axios = fetch.request;

    static downloadFile(data: any, fileName: string) {
        const blob = new Blob([data]), downloadElement = document.createElement('a'),
            href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
    }
}

export enum Status {
    // eslint-disable-next-line no-unused-vars
    PRIVATE,
    // eslint-disable-next-line no-unused-vars
    OPEN
}

export enum COURSE_EDITING_UPLOAD_TYPE {
    // eslint-disable-next-line no-unused-vars
    VIDEO = 2,
    // eslint-disable-next-line no-unused-vars
    AUDIO = 3,
    // eslint-disable-next-line no-unused-vars
    UNSET = 0,
}
export function getCourseEditingUploadType(type: UploadType): COURSE_EDITING_UPLOAD_TYPE {
    let resultType = COURSE_EDITING_UPLOAD_TYPE.UNSET;
    switch (type) {
        case UploadType.VIDEO:
            resultType = COURSE_EDITING_UPLOAD_TYPE.VIDEO;
            break;
        case UploadType.AUDIO:
            resultType = COURSE_EDITING_UPLOAD_TYPE.AUDIO;
            break;
    }
    return resultType;
}
export function getPrivateOrPublic(type: COURSE_EDITING_UPLOAD_TYPE) {
    let resultType = Status.OPEN;
    switch (type) {
        case COURSE_EDITING_UPLOAD_TYPE.VIDEO:
        case COURSE_EDITING_UPLOAD_TYPE.AUDIO:
            resultType = Status.PRIVATE;
            break;
    }
    return resultType;
}

export const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const currentYear = new Date().getFullYear();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要 +1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // 判断是否是今年
    return year === currentYear
        ? `${month}-${day} ${hours}:${minutes}`
        : `${year}-${month}-${day} ${hours}:${minutes}`;
};
